import axios from 'axios';
import _ from 'lodash';

export default {
  data() {
    return {
      query: '',
      productGroups: [],
      filteredProductGroups: [],
      productGroupsLoaded: false,
      debounced: null,

      error: {},
    };
  },

  watch: {
    query(searchString) {
      this.filterQuery(searchString);
    },
  },

  created() {
    this.fetchProductGroups();
  },

  methods: {
    fetchProductGroups() {
      this.error = {};

      let groupType = null;

      if (this.additionalData.related_type === 'App\\Models\\ProductMainGroup') {
        groupType = 'main';
      } else if (this.additionalData.related_type === 'App\\Models\\ProductIntermediateGroup') {
        groupType = 'intermediate';
      }

      axios.get(`/admin/api/v1/product-group/${groupType}`)
        .then((response) => {
          this.productGroups = response.data.product_groups;
          this.productGroupsLoaded = true;
        })
        .catch(() => {
          this.productGroups = [];
          this.productGroupsLoaded = true;

          this.error.message = 'Kunne ikke hente produktgrupper.';
        });
    },

    // Method that uses debounce function from lodash so that we don't send unnecessary requests
    filterQuery: _.debounce(function (searchString) {
      if (this.query === '') {
        this.filteredProductGroups = [];
      } else {
        this.filteredProductGroups = this.productGroups.filter(productGroup => (
            productGroup.visma_group_id.toLowerCase().includes(searchString.toLowerCase()) ||
            productGroup.name.toLowerCase().includes(searchString.toLowerCase())
          ));
      }
    }, 250),
  },
};
